// extracted by mini-css-extract-plugin
export var truncate = "_t-0";